(function () {
  if (customElements.get('cart-document-type')) return;

  class CartDocumentType extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.billingMenu = this.querySelector('[data-document-billing]');
      this.documentSelectors = this.querySelectorAll('.document-type-selector');
      this.fields = this.querySelectorAll('[data-document-field]');
      this.rutField = this.querySelector('[data-document-field="rut"]');
      this.error = this.querySelector('[data-document-error]');
      this.checkoutButtons = this.form && this.form.querySelector('[data-cart-checkout-buttons]');
      this.checkoutButton = this.form && this.form.querySelector('[name="checkout"]');

      if (!this.form || !this.billingMenu || !this.rutField) return;

      this.restoreState();
      this.bindEvents();
      this.updateDocumentType();
    }

    bindEvents() {
      this.documentSelectors.forEach((selector) => {
        selector.addEventListener('change', () => {
          this.updateState();
          this.updateDocumentType();
        });
      });

      this.fields.forEach((field) => {
        field.addEventListener('input', () => {
          this.updateState();
          this.validate(false);
        });
      });

      this.rutField.addEventListener('blur', () => {
        this.formatRut();
        this.updateState();
        this.validate(false);
      });

      this.form.addEventListener('submit', (event) => {
        if (this.validate(true)) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        this.focusFirstInvalidField();
      }, true);

      if (this.checkoutButtons) {
        this.checkoutButtons.addEventListener('click', (event) => {
          if (this.validate(true)) return;

          event.preventDefault();
          event.stopImmediatePropagation();
          this.focusFirstInvalidField();
        }, true);
      }
    }

    getDocumentType() {
      const selected = this.querySelector('.document-type-selector:checked');
      return selected ? selected.value : 'boleta';
    }

    isInvoice() {
      return this.getDocumentType() === 'factura';
    }

    updateDocumentType() {
      const isInvoice = this.isInvoice();

      this.fields.forEach((field) => {
        const isRut = field === this.rutField;
        const fieldContainer = field.closest('.lab51-cart-document__field');

        field.required = isRut || isInvoice;
        if (fieldContainer) fieldContainer.hidden = !isRut && !isInvoice;

        if (!isInvoice && !isRut) {
          field.value = '';
          field.setCustomValidity('');
          field.removeAttribute('aria-invalid');
          field.classList.remove('valido', 'invalido');
        }
      });

      this.updateState();
      this.validate(false);
    }

    cleanRut(value) {
      return String(value || '').toUpperCase().replace(/[^0-9K]/g, '');
    }

    isValidRut(value) {
      const rut = this.cleanRut(value);

      if (rut.length < 8) return false;

      const body = rut.slice(0, -1);
      const verifier = rut.slice(-1);

      if (!/^\d+$/.test(body)) return false;

      let sum = 0;
      let multiplier = 2;

      for (let index = body.length - 1; index >= 0; index -= 1) {
        sum += Number(body.charAt(index)) * multiplier;
        multiplier = multiplier < 7 ? multiplier + 1 : 2;
      }

      const result = 11 - (sum % 11);
      const expectedVerifier = result === 11 ? '0' : result === 10 ? 'K' : String(result);

      return verifier === expectedVerifier;
    }

    formatRut() {
      const rut = this.cleanRut(this.rutField.value);

      if (rut.length < 2) return;

      this.rutField.value = `${rut.slice(0, -1)}-${rut.slice(-1)}`;
    }

    validate(showError) {
      const isInvoice = this.isInvoice();
      let isValid = true;

      this.fields.forEach((field) => {
        const isRut = field === this.rutField;
        const isRequired = isRut || isInvoice;
        if (!isRequired) return;

        const fieldIsValid = isRut ? this.isValidRut(field.value) : field.value.trim() !== '';

        field.setCustomValidity(fieldIsValid ? '' : isRut ? 'Ingresa un RUT válido.' : 'Completa este campo.');
        field.toggleAttribute('aria-invalid', !fieldIsValid);

        if (isRut) {
          field.classList.toggle('valido', field.value.trim() !== '' && fieldIsValid);
          field.classList.toggle('invalido', field.value.trim() !== '' && !fieldIsValid);
        }

        if (!fieldIsValid) isValid = false;
      });

      this.setCheckoutState(isValid);
      this.error.textContent = isInvoice
        ? 'Completa los datos de facturación e ingresa un RUT válido para continuar.'
        : 'Ingresa un RUT válido para continuar.';
      this.error.hidden = isValid || !showError;

      return isValid;
    }

    setCheckoutState(isValid) {
      if (this.checkoutButton) {
        this.checkoutButton.disabled = !isValid;
        this.checkoutButton.setAttribute('aria-disabled', String(!isValid));
      }

      if (this.checkoutButtons) {
        this.checkoutButtons.classList.toggle('lab51-cart-document--disabled', !isValid);
        this.checkoutButtons.setAttribute('aria-disabled', String(!isValid));
      }
    }

    focusFirstInvalidField() {
      const invalidField = Array.from(this.fields).find((field) => !field.checkValidity());
      if (invalidField) invalidField.focus();
    }

    updateState() {
      window.lab51CartDocumentState = {
        documentType: this.getDocumentType(),
        rut: this.querySelector('[data-document-field="rut"]').value,
        razon: this.querySelector('[data-document-field="razon"]').value,
        giro: this.querySelector('[data-document-field="giro"]').value,
      };
    }

    restoreState() {
      const state = window.lab51CartDocumentState;
      if (!state) return;

      const selected = this.querySelector(`.document-type-selector[value="${state.documentType}"]`);
      if (selected) selected.checked = true;

      this.querySelector('[data-document-field="rut"]').value = state.rut || '';
      this.querySelector('[data-document-field="razon"]').value = state.razon || '';
      this.querySelector('[data-document-field="giro"]').value = state.giro || '';
    }
  }

  customElements.define('cart-document-type', CartDocumentType);
})();
